// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"riverpro_animationWrapper__lob0L"};